import{PRODUCT_TYPES as r}from"../../constants/productTypes.js";var t=function(t,o){return t===r.CONTACT_LENSES&&o?"Subscription":""};export{t as getSubscriptionForLenses};
//# sourceMappingURL=getSubscriptionForLenses.js.map
